export default function defaultGrouping({ stateInfos }) {
  return [
    {
      title: 'Skip ahead to a specific state',
      states: stateInfos,
    },
  ];
}
